/**
 * Reusable editorial page header for sub-pages.
 * Big eyebrow, oversized chrome headline, slim subhead.
 */
import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, sub, children }) {
  return (
    <section
      data-testid="page-header"
      className="relative pt-40 sm:pt-52 pb-20 sm:pb-28 ocean-glow"
    >
      <div className="absolute inset-0 subtle-grid pointer-events-none opacity-80" />
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-[480px] w-[900px] rounded-full bg-[#0055FF]/18 blur-[140px]" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-zinc-500"
        >
          <span className="h-px w-6 bg-zinc-700" />
          {eyebrow}
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, delay: 0.05 }}
          className="font-display mt-6 text-5xl sm:text-7xl lg:text-[92px] lg:leading-[1.0] font-semibold tracking-tighter chrome-text max-w-5xl"
        >
          {title}
        </motion.h1>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-8 text-[16px] sm:text-[19px] text-zinc-400 leading-relaxed max-w-2xl"
          >
            {sub}
          </motion.p>
        )}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
